import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Home, MobileHome, SwapDetail, SwapCreate, Wrappedtokens } from "./Routes/routes";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";

class App extends React.Component {

  isMobile = () => {
    //return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile/i.test(navigator.userAgent);
  }

  render() {
    if(this.isMobile()) {
      return (
        <div className="Root-div">
          <link href="https://fonts.googleapis.com/css?family=Exo|Exo+2|Montserrat|Montserrat:300|Montserrat:500|Montserrat:700|Titillium+Web|Ubuntu+Mono&display=swap" rel="stylesheet" />
          <link href='//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSans-kr.css' rel='stylesheet' type='text/css' />
          <Router>
            <Header/>
              <Switch>
                <Route exact path="/" component={MobileHome} />
                <Route exact path="/search/:pair" component={MobileHome} />
              </Switch>
              <Footer/>
            </Router>
        </div>
      );
    } else {
      return (
        <div className="Root-div">
          <link href="https://fonts.googleapis.com/css?family=Exo|Exo+2|Montserrat|Montserrat:300|Montserrat:500|Montserrat:700|Titillium+Web|Ubuntu+Mono&display=swap" rel="stylesheet" />
          <link href='//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSans-kr.css' rel='stylesheet' type='text/css' />
          {this.isMobile()}
          <Router>
            <Header/>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/search/:pair" component={Home} />
                <Route exact path="/wrappedtokens" component={Wrappedtokens} />
                <Route exact path="/swap/:pair/:uid" component={SwapDetail} />
                <Route exact path="/createswap/:pair" component={SwapCreate} />
              </Switch>
              <Footer/>
            </Router>
        </div>
      );
    }
  }
}

export default App;
